var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-active-element',{staticClass:"ui-tag",class:{'active': _vm.localIsSelected},attrs:{"disabled":!_vm.isSelectable && !_vm.isLinks},on:{"click":_vm.onClick}},[_c('app-icon',{attrs:{"name":_vm.ICON_NAMES.TAG}}),_vm._v(" "),_c('span',{staticClass:"ui-tag-text"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }